<template>
  <div class="horizontal-month-picker">
  		<div class="swiper-button-all-wrapper">
      <button @click="resetDateRange()" class="swiper-button-all" :class="isViewingAll() ? 'active' : ''">All</button></div>

   <div class="swiper-container">
      <!-- Additional required wrapper -->
      <div class="swiper-wrapper">
          <!-- Slides -->
          <div class="swiper-slide" v-for="date in dates" @click="setDateRange(date)" :class="isDateActive(date) ? 'active' : ''"><span>{{date.label}}</span></div>
      </div>

      <div class="swiper-button-prev"><svg xmlns="http://www.w3.org/2000/svg" width="10.93" height="12.621" viewBox="0 0 10.93 12.621"><path d="M-1735.9-950.024l10.93,6.31v-12.621Z" transform="translate(1735.899 956.335)" fill="#2d3135"/></svg></div>


      <div class="swiper-button-next"><svg xmlns="http://www.w3.org/2000/svg" width="10.93" height="12.621" viewBox="0 0 10.93 12.621"><path d="M-246.466-949.024l-10.93-6.31v12.621Z" transform="translate(257.396 955.335)" fill="#2d3135"/></svg></div>
  </div>


  </div>
</template>

<script>

// for some reason neither "swiper/vue" as per swiperjs's vue documentation or "swiper/vue/swiper-vue" as suggested by a stackoverflow question worked
import { Swiper, Navigation } from 'swiper';

// Import Swiper styles, as to why it is "swiper/swiper-bundle.css" and not "swiper/css" as per swiperjs's documentation see: https://stackoverflow.com/questions/69421228/this-dependency-was-not-found-swiper-vue-how-to-fix and https://stackoverflow.com/questions/64260924/render-function-or-template-not-defined-in-component-swiper which suggested that and seems to work for me.
import "swiper/swiper-bundle.css";

import Vue from "vue";
import { mapMutations, mapState } from "vuex";
import router from "../../routes";

export default {
  components: {
    Swiper,
    Navigation,
    Vue
  },
  data() {
    return {
    	createdDateSort:false,
      months: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
      currentYear: new Date().getFullYear(),
      dates: [],
      default_date: '',
      selected_date: '',
      filterQuery: {
        sort: "",
        query: "",
        filterByDate: false,
        filterByTaskDate: false,
        listByDateField:"publish_date",
        listByDate:true,
        dateRange: {
          startDate: new Date(),
          endDate: new Date(),
        },
        taskDateRange: {
          startDate: new Date(),
          endDate: new Date(),
        },
        dateCreatedRange: {
          startDate: new Date(),
          endDate: new Date(),
        },
        dateCompletedRange: {
          startDate: new Date(),
          endDate: new Date(),
        },
        datePublishRange: {
          startDate: new Date(),
          endDate: new Date(),
        },
        listByDateRange: {
          startDate: new Date(),
          endDate: new Date(),
        },
        status: [],
        outlet: [],
        deliverableType: [],
        tag: [],
        department: [],
        coordinator: [],
        project: [],
        parentDeliverableId: 0,
        noDepartment: "not_accepted",
        noOutlet: "not_accepted",
        weekFilterOptions: {
          overdue: false,
          today: false,
          thisWeek: false,
          nextWeek: false,
          upcoming: false,
          noDeadline: false,
        }
      },
    }
  },
  props: ["namespace", "parentDeliverableId"],
  beforeMount() {
    this.filterQuery = this.socialMediaFilter;

    let prevYear = this.currentYear - 1;
    let nextYear = this.currentYear + 1;
    for (var i = 0; i < this.months.length; i++) {
      var month = this.months[i];
      var month_number = i+1+'';
          month_number = month_number.length < 2 ? '0'+month_number : month_number;
      var date_str = prevYear+'-'+month_number;      
      this.dates.push({
        label: month + ' ' + prevYear,
        startDate: Vue.moment(date_str).toDate(),
        endDate: Vue.moment(date_str).endOf('month').toDate()
      });
    }
    for (var i = 0; i < this.months.length; i++) {
      var month = this.months[i];
      var month_number = i+1+'';
          month_number = month_number.length < 2 ? '0'+month_number : month_number;
      var date_str = this.currentYear+'-'+month_number;      
      this.dates.push({
        label: month + ' ' + this.currentYear,
        startDate: Vue.moment(date_str).toDate(),
        endDate: Vue.moment(date_str).endOf('month').toDate()
      });
    }
    for (var i = 0; i < this.months.length; i++) {
      var month = this.months[i];
      var month_number = i+1+'';
          month_number = month_number.length < 2 ? '0'+month_number : month_number;
      var date_str = nextYear+'-'+month_number;      
      this.dates.push({
        label: month + ' ' + nextYear,
        startDate: Vue.moment(date_str).toDate(),
        endDate: Vue.moment(date_str).endOf('month').toDate()
      });
    }
    this.default_date = this.months[new Date().getMonth()] + ' ' + new Date().getFullYear();
  },
  mounted() {



    var date_swiper = new Swiper('.horizontal-month-picker .swiper-container', {
      modules: [Navigation],
      loop: false,
      slidesPerView: 2,
      slidesPerGroup: 2,
      initialSlide: 13,
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
      breakpoints: {
        1366: {
          slidesPerView: 12,
          slidesPerGroup: 12,
          // initialSlide: 13,
        },
        768: {
          slidesPerView: 6,
          slidesPerGroup: 6,
          // initialSlide: 9,
        },
        400: {
          slidesPerView: 3,
          slidesPerGroup: 3,
          // initialSlide: 5,
        }
      }
    });

    let that = this;
    var is_swiper_tranistioning = false; // prevent infinite slideTo loop
    date_swiper.on('slideNextTransitionEnd', function() {
      if(is_swiper_tranistioning) return; // if we are calling slideTo from in here don't fire this event again
      is_swiper_tranistioning = true;
      // if the next slide will have less months then there are slides per view add the next years slides
      if( date_swiper.slides.length - date_swiper.activeIndex <= date_swiper.params.slidesPerView ) {
        that.currentYear++;
        let nextYear = that.currentYear + 1
        for (var i = 0; i < that.months.length; i++) {
          that.dates.splice(0,1);

          var month_number = i+1+'';
              month_number = month_number.length < 2 ? '0'+month_number : month_number;
          var date_str = nextYear+'-'+month_number;

          that.dates.push({
            label: that.months[i] + ' ' + nextYear,
            startDate: Vue.moment(date_str).toDate(),
            endDate: Vue.moment(date_str).endOf('month').toDate()
          });
        }
        // update for swiper to regester the new slides
        date_swiper.update();
        // since the new slides change the slide index we need to do a quick swap to the new correct position, 0ms to not show it
        date_swiper.slideTo(date_swiper.activeIndex - that.months.length, 0);
      }
      
      is_swiper_tranistioning = false;
    });

    date_swiper.on('slidePrevTransitionEnd', function() {
      if(is_swiper_tranistioning) return;
      is_swiper_tranistioning = true;   
      if( date_swiper.activeIndex <= date_swiper.params.slidesPerView ) {
        that.currentYear--;
        let prevYear = that.currentYear - 1
        for (var i = that.months.length - 1; i >= 0; i--) {
          that.dates.splice(that.dates.length-1,1);

          var month_number = i+1+'';
              month_number = month_number.length < 2 ? '0'+month_number : month_number;
          var date_str = prevYear+'-'+month_number;

          that.dates.unshift({
            label: that.months[i] + ' ' + prevYear,
            startDate: Vue.moment(date_str).toDate(),
            endDate: Vue.moment(date_str).endOf('month').toDate()
          });
        }
        date_swiper.update();
        date_swiper.slideTo(that.months.length + date_swiper.activeIndex, 0);
      }

      is_swiper_tranistioning = false;
    });

  },
  methods: {
  	...mapMutations({
  	  setDataLoading (commit, payload) {
  	    return commit(this.namespace + 'setDataLoading', payload)
  	  },
  	}),
    isDateActive(date) {
      return (this.filterQuery.listByDate && Vue.moment(this.filterQuery.listByDateRange.startDate).isSame(date.startDate, "month") && Vue.moment(this.filterQuery.listByDateRange.endDate).isSame(date.endDate, "month") && Vue.moment(this.filterQuery.listByDateRange.startDate).isSame(date.startDate, "year") && Vue.moment(this.filterQuery.listByDateRange.endDate).isSame(date.endDate, "year") );
    },
    isViewingAll() {
    	return (this.filterQuery.listByDateRange.startDate == null && this.filterQuery.listByDateRange.endDate == null);
    },
    setDateRange(date) {
    	// reset to the current socialMediaFilter.
    	this.filterQuery = this.socialMediaFilter;

      this.filterQuery.listByDate = true;

      // if we are clicking on the already active date unset it
      // Changed to use 'listByDate' instead of 'filterByPublishDate'
      if(this.isDateActive(date)) {
        this.filterQuery.listByDateRange = {
          startDate: new Date(),
          endDate: new Date(),
        };
        this.filterQuery.listByDate = true;
				this.applyFilter();
        return;
      }

      this.filterQuery.listByDateRange = {
        startDate: date.startDate,
        endDate: date.endDate
      }
			this.applyFilter();
    },
    resetDateRange() {
      this.filterQuery.listByDate = true;
    	this.filterQuery.listByDateRange = {
    		  startDate: null,
    		  endDate: null,
    		};
    		this.applyFilter();
    },

    applyFilter() {
    	this.filterQuery["parentDeliverableId"] = this.parentDeliverableId;

    	this.$root.$emit(this.namespace+'socialMediaFilterQueryUpdate', {
    	  currentFilter: this.filterQuery,
    	  namespace: this.namespace,
    	  filterParams: {
    	  	page:1
    	  }
    	});
    }

  },
  computed: {
  		...mapState({
  	  state (state) {
  	    return state[this.namespace]
  	  },
  	  socialMediaFilter (state, getters) {
  	    return getters[this.namespace + 'socialMediaFilter']
  	  },
  	}),
  },
};

</script>